<template>
	<div class="panel_settlement">
		<div style="padding-top:7px;">
			<span class="priceItem" style="margin-right:20px;">
				<span class="label">总计：</span>
				<span class="price">￥{{saleTotal.total}}</span>
			</span>
			<span class="priceItem" style="margin-right:0px;">
				<span class="label">优惠：</span>
				
				<el-popover
				v-if="curDiscountCard&&curDiscountCard._id"
				placement="top-start"
				title=""
				width="200"
				trigger="hover"
				>
					<span class="priceItem" style="font-size: 12px;" v-if="curDiscountCard&&curDiscountCard._id">
						{{curDiscountCard.coupon_name}}({{$public.getDiscountType(curDiscountCard.apply_range.order_type)}}券)
						<span v-if="curDiscountCard.activity_type===1">
							满{{curDiscountCard.money_top}}元可用
						</span>
						<span v-if="curDiscountCard.activity_type===2">
							满{{curDiscountCard.rebate_top}}元可用，
							<span v-if="curDiscountCard.rebate_limit>0">最高抵扣{{curDiscountCard.rebate_limit}}元</span>
							<span v-else></span>
						</span>
						<span style="color:#1890FF;cursor: pointer;" @click="delDiscountCard">删除</span>
					</span>
					<span class="price" slot="reference">￥{{$public.jian(saleTotal.total,saleTotal.activity)}}</span>
				</el-popover>
				<span class="price" v-else>￥{{$public.jian(saleTotal.total,saleTotal.activity)}}</span>
			</span>
		</div>
		<div>
			<span class="priceItem" style="margin-right:5px;">
				<span class="label">应付：</span>
				<span class="price" style="color:#FF2F2F;">￥{{saleTotal.activity}}</span>
			</span>
			<el-button style="width:110px;" type="warning" size="small" plain @click="delDiscountCard" v-if="curDiscountCard&&curDiscountCard._id">取消优惠券</el-button>
			<el-button style="width:80px;" type="warning" size="small" plain @click="openDiscountCard" v-else>优惠券</el-button>
			<el-button style="width:80px;" type="warning" size="small" plain @click="drawerRemark_state=true">备注</el-button>
			<el-button style="width:100px;" type="warning" size="small" @click="submitOrder">生成订单</el-button>
		</div>
		<!-- 优惠券 -->
		<div v-show="drawerDiscountCard_state">
			<drawerDiscountCard :userId="userInfo._id" :state="drawerDiscountCard_state" :money="saleTotal.total" :goodsList="saleList" :type="1" @submit="submit_drawerDiscountCard"></drawerDiscountCard>
		</div>
		<!-- 备注弹窗 -->
		<div v-if="drawerRemark_state">
			<drawerRemark :type="'jiyangguanli'" @submit="submit_drawerRemark"></drawerRemark>
		</div>
	</div>
</template>
<script>
	import drawerDiscountCard from "../../views/mendian/shouyin/drawer/discountCard.vue"
	import drawerRemark from "../../views/mendian/shouyin/drawer/remark.vue"
	import del from "../../util/del.js"
	export default {
		components:{drawerDiscountCard,drawerRemark},
		data(){
			return{
				o:null,
				// 优惠券
				drawerDiscountCard_state:false,
				// 备注
				drawerRemark_state:false,
			}
		},
		computed:{
			goodsItemsId(){
				return this.$store.state.jiyangguanli.goodsItemsId;
			},
			userInfo(){
				return this.$store.state.jiyangguanli.userInfo;
			},
			curDiscountCard(){
				return this.$store.state.jiyangguanli.curDiscountCard;
			},
			saleList(){
				return this.$store.state.jiyangguanli.saleList;
			},
			saleTotal(){
				return this.$store.state.jiyangguanli.saleTotal;
			},
			remark(){
				return this.$store.state.jiyangguanli.remark;
			},
		},
		mounted(){
			this.o = new del();
		},
		methods:{
			// 创建订单
			submitOrder(){
				let loading = this.$loading()
				this.o.init(this.saleList)
						if(this.saleList.length>0){
							let orderGoods = [];
							let tableData = this.saleList;
							for(let i=0;i<tableData.length;i++){
								let one = {
									"goodsId": tableData[i].goodsId,          // 销售对象id
									"goodsName": tableData[i].goodsName,        // 销售对象名字
									"goodsType": tableData[i].goodsType,             
									"brand": tableData[i].brand,
									"categoryId": tableData[i].categoryId,
									"categoryName": tableData[i].categoryName,
									"petId": tableData[i].petId,          // 销售对象id
									"petName": tableData[i].petName,          // 销售对象id
									"skus": tableData[i].skus,
									"skuValue": tableData[i].skuValue,
									"unitId": tableData[i].unitId,
									"unit": tableData[i].unit,
									"originalPrice": tableData[i].originalPrice,
									"price": tableData[i].price,
									"num": parseInt(tableData[i].num),
									"activityId": tableData[i].activityId,
									"activityName": tableData[i].activityId?tableData[i].activityItem.name:'',
									"payType": tableData[i].activityId?tableData[i].activityItem.pay_type:'',
									"totalMoney": 0,
									"salesMans": tableData[i].salesMans,
									goodsList:[],
								}
								if(tableData[i].activityType===5){ // 使用了抵扣券
									one.activityId = this.curDiscountCard._no
									one.activityType = 5
									one.activityName = '抵扣券'
								}
								for(let a=0;a<tableData[i].goodsList.length;a++){
									let two = {
										"goodsId": tableData[i].goodsList[a].goodsId,      // 商品id
										"goodsName": tableData[i].goodsList[a].goodsName,    // 商品名称
										"customBarCode": tableData[i].goodsList[a].customCode, // 条码
										"price": tableData[i].goodsList[a].price,               // 销售价格
										"costPrice": tableData[i].goodsList[a].costPrice,               // 销售价格
										"skus": tableData[i].goodsList[a].skus,
										"skuValue": tableData[i].goodsList[a].skuValue,
										"model": tableData[i].goodsList[a].skuValue,        // 商品规格
										"unitId": tableData[i].goodsList[a].unitId,
										"unit": tableData[i].goodsList[a].unit,
										"expiryDate": tableData[i].goodsList[a].validityStopDate,     // 有效期
										goodsSalesModel:1,  // 0老数据   1出售   2赠品
									}
									one.goodsList.push(two);
								}
								if(!this.$public.isNull(tableData[i].giftList)){
									for(let a=0;a<tableData[i].giftList.length;a++){
										for(let b=0;b<tableData[i].giftList[a].goodsList.length;b++){
											let wayItem = tableData[i].giftList[a].goodsList[b];
											let two = {
												"goodsId": wayItem.goodsId,      // 商品id
												"goodsName": wayItem.goodsName,    // 商品名称
												"customBarCode": wayItem.customCode, // 条码
												"price": wayItem.price,               // 销售价格
												"costPrice": wayItem.costPrice||0,               // 销售价格
												"skus": wayItem.skus,
												"skuValue": wayItem.skuValue,
												"model": wayItem.skuValue,        // 商品规格
												"unitId": wayItem.unitId,
												"unit": wayItem.unit,
												"expiryDate": wayItem.validityStopDate,     // 有效期
												goodsSalesModel:2,  // 0老数据   1出售   2赠品
											}
											one.goodsList.push(two);
										}
									}
								}
								if(tableData[i].staff.length==0){
									this.$message({
										message: '请选择销售人员',
										type: 'error'
									});
									loading.close();
									return ;
								}
								orderGoods.push(one);
							}
							let memberId = this.userInfo._id;
							let memberName = this.userInfo.basic_info.nick_name;
							let memberMobile = this.userInfo.basic_info.user_mobile;
							let params = {
								"memberId": memberId,
								"memberName": memberName,
								"memberMobile":memberMobile,
								"totalMoney": 0,
								"remark": this.remark,      // 订单备注
								coupon_no:this.curDiscountCard!==null?this.curDiscountCard._no:'',
								"orderGoods": orderGoods,
								other_param:this.goodsItemsId,
								useVipPrice:true
							}
							this.$http.post('/api/Order/CreateGoodsOrder', params).then(res => {
								loading.close();
								if (res.code == 0) {
									this.$emit("submit",{type:'success'})
								}
							})
						}else{
							this.$message({
								message: '没有待结算的订单',
								type: 'error'
							});
							loading.close();
							return ;
						}
					
				
			},
			// 优惠券
			openDiscountCard(){
				if (this.saleList.length > 0) {
					let canCard = true;
					for(let i=0;i<this.saleList.length;i++){
						if(!this.$public.isNull(this.saleList[i].activityId)){
							canCard=false
						}
					}
					if(canCard===false){
						this.$message({
							message: '选择活动后不可使用优惠券！！',
							type: 'error'
						});
					}else{
						this.drawerDiscountCard_state = true;
					}
				} else {
					this.$message({
						message: '请添加商品',
						type: 'error'
					});
				}
			},
			submit_drawerDiscountCard(obj){
				console.log(obj)
				if(obj.type==="submit"){
					this.$store.commit('jiyangguanli/set_saleTotal',{total:this.saleTotal.total, activity:obj.newMoney})
					this.$store.commit('jiyangguanli/set_curDiscountCard',obj.card)
					if(obj.card.activity_type===3){ // 抵扣券
						let item1 = obj.card.canList[0];
						for(let i=0;i<this.saleList.length;i++){
							let item2 = this.saleList[i];
							if(item1.goodsId===item2.goodsId&&item1.skus===item2.skus&&item1.unitId===item2.unitId){
								this.saleList[i].activityType=5;
							}
						}
					}
					this.$store.commit("jiyangguanli/set_saleList",this.saleList)
					this.drawerDiscountCard_state = false;
				}else{
					this.drawerDiscountCard_state = false;
				}
			},
			delDiscountCard(){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					this.$store.commit('jiyangguanli/set_saleTotal',{total:this.saleTotal.total, activity:this.saleTotal.total})
					for(let i=0;i<this.saleList.length;i++){
						this.saleList[i].activityType=1;
					}
					this.$store.commit("jiyangguanli/set_saleList",this.saleList)
					this.$store.commit("jiyangguanli/set_curDiscountCard",null)
				})
			},
			// 备注
			submit_drawerRemark(){
				this.drawerRemark_state=false;
			},
		}
	}
</script>
<style scoped lang="scss">
.panel_settlement{
	display: flex;
	justify-content: space-between;
	padding:10px 20px;
	background-color: #fff;
	box-shadow: 0 -3px 5px 0px #ccc;
	.priceItem{
		display: inline-flex;align-items: center;
		margin-right: 40px;
		.label{
			font-size: 14px;color:$fontColor;
		}
		.price{
			font-size: 20px;color:$fontColor;
		}
	}
}
</style>
